/**
 * Privacy-safe Plausible custom events. No PII in props.
 * Enable with VITE_ENABLE_ANALYTICS=true and VITE_PLAUSIBLE_DOMAIN=your.domain.
 */

type PlausibleFn = (
  event: string,
  options?: { props?: Record<string, unknown> },
) => void

type PlausibleLike = PlausibleFn & {
  q?: unknown[][]
}

declare global {
  interface Window {
    plausible?: PlausibleLike
  }
}

export function initPlausible(): void {
  if (import.meta.env.VITE_ENABLE_ANALYTICS !== 'true') return
  const domain = import.meta.env.VITE_PLAUSIBLE_DOMAIN
  if (!domain || typeof document === 'undefined') return

  const w = window as Window & { plausible?: PlausibleLike }

  if (!w.plausible) {
    const stub: PlausibleLike = Object.assign(
      (...args: unknown[]) => {
        stub.q!.push(args)
      },
      { q: [] as unknown[][] },
    )
    w.plausible = stub
  }

  const s = document.createElement('script')
  s.defer = true
  s.setAttribute('data-domain', domain)
  s.src = 'https://plausible.io/js/script.tagged-events.js'
  document.head.appendChild(s)
}

export function trackEvent(
  name: string,
  props?: Record<string, string | number | boolean>,
): void {
  if (import.meta.env.VITE_ENABLE_ANALYTICS !== 'true') return
  window.plausible?.(name, {
    props: props as Record<string, unknown> | undefined,
  })
}
